import { isEmpty } from 'lodash'

import {
    IOrderCreationDto,
    IOrderDetailsApiDto,
    TOrderCreationApiReqDto,
    TWalletAddressDto,
} from './api.types'

const getWalletAddressApiReqDto = (walletAddressDto: TWalletAddressDto | {}) => {
    if (isEmpty(walletAddressDto)) {
        return {}
    }
    const walletDto = walletAddressDto as TWalletAddressDto

    //depositExtra: { extraId: depositExtraId, extraName: depositExtraName },
    // const extraAddressField = walletDto[extraId]
    // const tagDto = extraAddressField ? { [extraId]: extraAddressField } : {}

    return {
        // ...tagDto,
        address: walletDto.address,
    }
}

const mapOrderCreationDtoToReqApiDto = ({
    pairName,
    depositAmount,
    withdrawWalletAddressDto,
    paymentMethodId,
}: IOrderCreationDto): TOrderCreationApiReqDto => {
    let orderCreationApiReqDto = {
        is_default_rule: true,
        pair: { name: pairName },
        amount_quote: depositAmount,
        withdraw_address: getWalletAddressApiReqDto(withdrawWalletAddressDto),
    } as TOrderCreationApiReqDto

    if (paymentMethodId) {
        // For crypto only orders
        orderCreationApiReqDto.payment_method = paymentMethodId
    }

    return orderCreationApiReqDto
}

const mapSellOrderCreationDtoToReqApiDto = ({
    pairName,
    depositAmount,
    paymentMethodId,
    order_type,
    payment_preference,
    refund_address
}: IOrderCreationDto): TOrderCreationApiReqDto => {
    let orderCreationApiReqDto = {
        is_default_rule: true,
        pair: { name: pairName },
        amount_quote: depositAmount,
        withdraw_address: {},
        order_type,
        payment_preference,
        refund_address
    } as TOrderCreationApiReqDto

    return orderCreationApiReqDto
}

const mapOrderApiToOrderCreationDto = (
    orderApiDto: IOrderDetailsApiDto,
    withdrawWalletAddressDto: TWalletAddressDto,
): IOrderCreationDto => {
    // @ts-ignore
    const { amount_quote, amount_base, payment_method, pair } = orderApiDto
    const {
        name: pairName,
        quote: { code: depositCoinCode },
        base: { code: withdrawCoinCode },
    } = pair

    const orderCreationDto = {
        pairName,
        depositCoinCode,
        withdrawCoinCode,
        depositAmount: Number(amount_quote),
        withdrawAmount: Number(amount_base),
        paymentMethodId: payment_method,
        withdrawWalletAddressDto
    }

    if (!withdrawWalletAddressDto.address)
        delete orderCreationDto["withdrawWalletAddressDto"]["address"]

    return orderCreationDto
}
export { mapOrderCreationDtoToReqApiDto, mapSellOrderCreationDtoToReqApiDto, mapOrderApiToOrderCreationDto }
